var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPetAccessories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 26.53,
    viewBox: "0 0 32 26.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    id: "XMLID_135_",
    d: "M32,43.915V38.086H26.433l-9.89,4.873-9.89-4.873H1.086v2.268H0v1.293H1.086v2.268h4.2l4.66,2.3L1.086,50.576V57.21H15.9v2.41H14.691a2.5,2.5,0,0,0,0,5h3.7a2.5,2.5,0,1,0,0-5H17.189V57.21H32V50.576l-8.858-4.365,4.66-2.3H32ZM4.788,42.622H2.378v-.975H3.464V40.354H2.378v-.975h2.41v3.243Zm6.618,4.309,3.674,1.811-4.29,2.114H3.442Zm5.137,2.531,2.827,1.393H13.715Zm1.851,11.451a1.205,1.205,0,1,1,0,2.41h-3.7a1.205,1.205,0,0,1,0-2.41Zm12.313-5H2.378V52.148H30.707Zm-1.064-5.062H22.295L6.081,42.866V39.379h.271ZM21.679,45.49,18.005,43.68l8.729-4.3h3.973v3.243H27.5Zm-2.257,9.189H17.975V53.387h1.447Zm-8.623,0H9.352V53.387H10.8Zm-4.311,0H5.04V53.387H6.488Zm17.246,0H22.286V53.387h1.447Zm4.311,0H26.6V53.387h1.447Zm-12.934,0H13.663V53.387h1.447Z",
    transform: "translate(0 -38.086)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetAccessories);
export default __webpack_public_path__ + "static/media/petAccessories.b6b113ed2dd7d5683bf4fbc6e25fdc84.svg";
export { ForwardRef as ReactComponent };